import { render, staticRenderFns } from "./ImageAds.vue?vue&type=template&id=80d32ee6"
import script from "./ImageAds.vue?vue&type=script&lang=js"
export * from "./ImageAds.vue?vue&type=script&lang=js"
import style0 from "./ImageAds.vue?vue&type=style&index=0&id=80d32ee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports